import { Channel, Topic } from "../../../constants";
import { UserContextSelectors } from "../../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";

import { Brand } from "../../../configurations";
import { Item } from "../Models";
import { LocalizationMessages } from "../../../localization/messages";
import { MenuActionCreators } from "../../../redux/action-creators";
import { MenuItem } from "../MenuItem";
import { MessageBrokerUtils } from "../../../utils";
import PropTypes from "prop-types";
import React from "react";

const RegisterOrDepositMenuItem = ({ trackingInfo }) => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const dispatch = useDispatch();

  const depositButtonClicked = () => {
    MessageBrokerUtils.publish({
      channel: Channel.PAYMENT,
      topic: Topic.CTA_Quick_Deposit,
      headers: {
        publisher: "UAA"
      },
      data: {
        TabId: 16,
        Area: "Hamburger menu",
        Element: "Deposit button",
        Source: "Unified Client"
      }
    });
    dispatch(MenuActionCreators.hideHamburgerMenu());
  };

  const registerButtonClicked = () => {
    MessageBrokerUtils.publish({
      channel: Channel.PLAYER,
      topic: Topic.CTA_NRS_Open,
      headers: {
        publisher: "UAA"
      }
    });
    dispatch(MenuActionCreators.hideHamburgerMenu());
  };

  const getRegisterButton = () => {
    switch (brandId) {
      case Brand.Sport_Scasino:
      case Brand.Sport_Spoker: {
        return null;
      }
      default: {
        const registerItem = new Item({
          title: LocalizationMessages.registerButtonText,
          iconKey: "register"
        });

        return (
          <MenuItem
            item={registerItem}
            className="RegisterBtn"
            onClick={registerButtonClicked}
            automationId="uc-register"
            trackingInfo={trackingInfo}
          />
        );
      }
    }
  };

  const getDepositButton = () => {
    switch (brandId) {
      case Brand.Sport_Spoker: {
        return null;
      }
      default: {
        return (
          <MenuItem
            className="DepositBtn"
            onClick={depositButtonClicked}
            item={
              new Item({
                title: LocalizationMessages.deposit,
                iconKey: "deposit"
              })
            }
            automationId="uc-Cashier"
            trackingInfo={trackingInfo}
          />
        );
      }
    }
  };

  return isAuthenticated ? getDepositButton() : getRegisterButton();
};

RegisterOrDepositMenuItem.propTypes = {
  trackingInfo: PropTypes.object
};

export default React.memo(RegisterOrDepositMenuItem);
